/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileMini,
    MediaFileMiniFromJSON,
    MediaFileMiniFromJSONTyped,
    MediaFileMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileBundleMiniReference
 */
export interface MediaFileBundleMiniReference {
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundleMiniReference
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundleMiniReference
     */
    readonly asset?: number;
    /**
     * 
     * @type {string}
     * @memberof MediaFileBundleMiniReference
     */
    readonly name?: string;
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundleMiniReference
     */
    readonly location?: number;
    /**
     * 
     * @type {MediaFileMini}
     * @memberof MediaFileBundleMiniReference
     */
    mainfile?: MediaFileMini;
}

export function MediaFileBundleMiniReferenceFromJSON(json: any): MediaFileBundleMiniReference {
    return MediaFileBundleMiniReferenceFromJSONTyped(json, false);
}

export function MediaFileBundleMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileBundleMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'mainfile': !exists(json, 'mainfile') ? undefined : MediaFileMiniFromJSON(json['mainfile']),
    };
}

export function MediaFileBundleMiniReferenceToJSON(value?: MediaFileBundleMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'mainfile': MediaFileMiniToJSON(value.mainfile),
    };
}


